/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Locations API
 * AV Services Locations management API
 * OpenAPI spec version: 1.0
 */

/**
 * User role
 */
export type UserRole = (typeof UserRole)[keyof typeof UserRole];

export const UserRole = {
  READONLY: 'ReadOnly',
  CLIENTADMIN: 'ClientAdmin',
  SUPERADMIN: 'SuperAdmin',
} as const;
